<template>
    <div class="WonderfulSkit">
        <menuBox :step="3"></menuBox>
        <div class="service-1">
            <div class="title">Our Service</div>
            <p class="sbtitle">Provide you with the most professional and considerate services</p>
        </div>

        <div class="home-3">
            <div class="text">Innovative advertising, technology services</div>
            <div class="sbtext">In the digital age, advertising innovation and technology application are the keys to brand success. We integrate innovative advertising and technology services to provide you with comprehensive solutions</div>
            <div class="list-box">
                <div class="item">
                    <img src="../assets/1.png" alt="">
                    <div class="text-box">
                        <div>Creative advertising planning and design</div>
                        <p>Provide clients with innovative and attractive advertising planning and design solutions to highlight their brand image and core values.</p>
                    </div>
                </div>
                <div class="item">
                    <img src="../assets/2.png" alt="">
                    <div class="text-box">
                        <div>Multi-channel advertising</div>
                        <p>Advertise on various online and offline channels to reach a wide target audience.</p>
                    </div>
                </div>
                <div class="item">
                    <img src="../assets/3.png" alt="">
                    <div class="text-box">
                        <div>Website and App Development</div>
                        <p>Design and develop responsive websites and mobile applications to provide high-quality user experience and efficient brand display and interactive functions.</p>
                    </div>
                </div>
                <div class="item">
                    <img src="../assets/4.png" alt="">
                    <div class="text-box">
                        <div>Data analysis and marketing strategy</div>
                        <p>Utilize advanced data analysis technology to provide customers with in-depth analysis and effective marketing strategies to optimize advertising effects and increase conversion rates.</p>
                    </div>
                </div>
                <div class="item">
                    <img src="../assets/5.png" alt="">
                    <div class="text-box">
                        <div>Technical support and maintenance</div>
                        <p>Provide comprehensive technical support and maintenance services to ensure that customers' websites and applications maintain stable operation and security and meet their business needs.</p>
                    </div>
                </div>
                <div class="item">
                    <img src="../assets/6.png" alt="">
                    <div class="text-box">
                        <div>Personalized solutions and consultation</div>
                        <p>Provide personalized solutions and professional consulting services based on customer needs to help customers formulate the best advertising promotion and technology development strategies.</p>
                    </div>
                </div>

            </div>
        </div>

        <div class="home-5">
            <div class="title">Lgnite your creativity and contact us today!</div>
            <div class="sbtitle">Whether you're looking for a creative advertising strategy or need technical support, we're here to help. Please leave your contact information.</div>
            <div class="btn-box">
                <input type="text" v-model="name" placeholder="Your Name" class="input-box input-1">
                <input type="text" v-model="address" placeholder="Your email address" class="input-box input-2">
                <div class="btn" @click="SubmitOk">Submit</div>
            </div>
        </div>

        <div class="home-6">
            <div class="title">Excellent industry success stories</div>
            <div class="sbtitle">No matter what industry you are in, no matter what challenges you face, we are confident that we can provide you with the best solutions. Let our success stories inspire you and join hands with us to create brilliance!</div>
            <div class="list-box">
                <div class="item">
                    <img src="../assets/13.png" alt="">
                    <div>Retail industry</div>
                    <p>Designed creative advertisements and used social media and e-commerce platforms for precise placement</p>
                </div>
                <div class="item">
                    <img src="../assets/14.png" alt="">
                    <div>Technology industry</div>
                    <p>Designed advertising strategies targeting different customer groups and boosted their website traffic through search engine optimization (SEO)</p>
                </div>
                <div class="item">
                    <img src="../assets/15.png" alt="">
                    <div>Food Industry</div>
                    <p>Designed eye-catching advertising campaigns that combined online promotion and offline activities to attract more customers to the store.</p>
                </div>
                <div class="item">
                    <img src="../assets/16.png" alt="">
                    <div>Financial sector</div>
                    <p>Advertising strategies for different investment preferences and brand promotion of asset management services.</p>
                </div>
                <div class="item">
                    <img src="../assets/17.png" alt="">
                    <div>Culture and entertainment industry</div>
                    <p>Designed a compelling film campaign and promoted it using social media and cinema advertising.</p>
                </div>
                <div class="item">
                    <img src="../assets/18.png" alt="">
                    <div>Tourism and Hospitality Industry</div>
                    <p>Designed an engaging vacation package promotion campaign and optimized their booking system and customer service process.</p>
                </div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            name: '',
            address: ''
        }
    },
    mounted() {

    },
    methods: {
        SubmitOk() {
            if (!this.name) {
                return alert('please enter your name')
            } else if (!this.address) {
                return alert('please enter your email address')
            }
            alert('Submitted successfully')
        }
    }
}
</script>
<style lang="less" scoped>
.title {
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    text-align: center;
}

.sbtitle {
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 22px;
    text-align: center;
}

.service-1 {
    height: 375px;
    background: url(../assets/bg-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.home-3 {
    padding: 150px 360px;

    .sbtext {
        font-size: 20px;
        color: #999999;
        text-align: center;
    }

    .text {
        font-weight: normal;
        font-size: 40px;
        color: #333333;
        text-align: center;
    }

    .sbtext {
        margin-top: 24px;
    }

    .list-box {
        margin-top: 48px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        .item {
            width: 516px;
            height: 180px;
            background: #F9FAFB;
            box-shadow: inset 0px -2px 0px 0px #DDDDDD;
            padding: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 28px;

            img {
                width: 62px;
            }

            .text-box {
                width: 400px;

                div {
                    font-weight: 900;
                    font-size: 20px;
                    color: #333333;
                }

                p {
                    font-weight: 600;
                    font-size: 16px;
                    color: #999999;
                    margin-top: 15px;
                }
            }
        }
    }
}

.home-5 {
    padding: 0px 360px;
    background: url(../assets/bg-1.png);
    height: 465px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    .text {
        color: #FFFFFF;
    }

    .sbtext {
        margin-top: 22px;
        color: #FFFFFF;
    }

    .btn-box {
        width: 1100px;
        min-height: 50px;
        background: #FFFFFF;
        box-shadow: 0px 12px 24px 0px rgba(215, 215, 215, 0.5);
        padding: 57px 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 56px;

        .input-box {
            width: 324px;
            height: 56px;
            background: #EBEFF3;
            padding: 0px 20px;
            font-size: 18px;
            color: #999999;
        }

        .input-1 {
            width: 410px;
        }

        .input-2 {
            width: 280px;
        }

        .btn {
            font-weight: 600;
            font-size: 20px;
            color: #FFFFFF;
            padding: 0px 40px;
            background: #F8A419;
            height: 56px;
            line-height: 56px;
            width: 180px;
            text-align: center;
        }
    }
}

.home-6 {
    padding: 120px 360px;

    .title {
        color: #333333;
    }

    .sbtitle {
        color: #999999;
    }

    .list-box {
        margin-top: 80px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;

        .item {
            width: 320px;
            height: 280px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            text-align: center;

            img {
                width: 64px;
            }

            div {
                font-weight: 900;
                font-size: 20px;
                color: #333333;
                margin-top: 40px;
            }

            p {
                margin-top: 14px;
                font-weight: 600;
                font-size: 16px;
                color: #999999;
            }
        }
    }
}
</style>
